import { atom } from 'jotai'

export const isPostInvoiceSettingsPendingAtom = atom<boolean>(false)
